import {
  ReservationGroup,
  Reservation,
  PassRule,
  Vehicle,
  SpecificRule,
  Visitor,
  ReservationAuthority
} from '../../object'
import path from 'path'
import {handleError} from '../handleError'
import axios from 'axios'
const state = {
  globalConfig: {
    audioPromptIn: '访客用户欢迎光临',
    audioPromptOut: '访客用户移路平安',
    ledPromptIn: '访客用户|减速慢行|欢迎光临',
    ledPromptOut: '访客用户|减速慢行|一路平安'
  },
  personalAuth: new ReservationAuthority({
    name: '个人预约'
  }),
  orgAuth: new ReservationAuthority({
    name: '单位预约',
  }),
  letterAuth: new ReservationAuthority({
    name: '函件预约预约',
    maxVehicleAmount: 1000,
    maxStartDay: 30,
    maxDurationDay: 30
  }),
  adminAuth: new ReservationAuthority({
    // 必填，预约类型名称
    name: '高级预约',

    // 最小起始时间，为0则为当天，-1为无限
    minStartDay: -1,

    // 最大起始时间，为0则为当天，-1为无限
    maxStartDay: -1,

    // 时间片最小可选时间
    // minSliceTime: '00:00',

    // 时间片最大可选时间
    // maxSliceTime: '23:59',

    // 最大预约时段天数，为0则为仅限当天（起始日期 = 截止日期），-1为无限
    maxDurationDay: -1,

    // 最大配置规则数
    maxRuleAmount: 100,

    // 单次最大配置车辆数
    maxVehicleAmount: 1000,

    // 可使用的规则类型：sectional(时段型), day(按天循环), week(按周循环)
    type: ['sectional', 'day', 'week'],

    // 是否可以定义分组名称和描述
    editGroupInfo: true,

    // 是否可定义特殊进出场提示
    editPrompt: true
  })
}
const getters = {
  getPersonalAuth (state) {
    return state.personalAuth
  },
  getOrgAuth (state) {
    return state.orgAuth
  }
}

const mutations = {
  setPersonalAuth (state, data) {
    state.personalAuth = data
  },
  setOrgAuth (state, data) {
    state.orgAuth = data
  },
  setLetterAuth (state, data) {
    state.letterAuth = data
  },
  setAdminAuth (state, data) {
    state.adminAuth = data
  }
}

const actions = {
  async getReservations ({dispatch}, {pagination, sortStack, search, filter, type, locate = 'runtime', self = false}) {
    let map = {
      [Reservation.ADMIN]: 'admin',
      [Reservation.PERSONAL]: 'order_object',
      [Reservation.ORG]: 'order_group',
      [Reservation.LETTER_BUSINESS]: 'order_business',
      [Reservation.LETTER_WORK]: 'order_work',
      [Reservation.LETTER_APPEND]: 'order_append',
      [Reservation.LETTER_APPEND_SELF]: 'order_append_self'
    }
    let f = Object.assign({orderType: map[type] || ''}, filter || {})
    let {items, amount} = await dispatch('getDataList', {
      url: path.join('/passObjectApi/order/list/', self ? 'self' : ''),
      pagination,
      sortStack,
      search,
      transDict: {
        plate: 'visitorObjectCode',
        startDatetime: 'sdtime',
        endDatetime: 'edtime',
        status: 'RHData'
      },
      filter: f
    }, {root: true})
    return {
      items: items.map(item => {
        let order = item.order
        order.visitor = Visitor.fromAPI(item.visitor)
        order.owner = (item.personLiable === undefined || item.personLiable === null) ? {} : item.personLiable
        if (item.personLiable !== undefined && item.personLiable !== null) {
          order.owner.phone = (item.personLiable.mobilePhone === null) ? '' : item.personLiable.mobilePhone
        }
        else {
          order.owner.phone = ''
        }
        order.applicant = (item.user === undefined || item.user === null) ? {} : item.user
        if (item.user !== undefined && item.user !== null) {
          order.applicant.phone = (item.user.mobilePhone === null) ? '' : item.user.mobilePhone
        }
        else {
          order.applicant.phone = ''
        }
        return Reservation.fromAPI(order)
      }),
      amount
    }
  },
  async getReservationsHistory ({dispatch}, {pagination, sortStack, search, filter, type, self = false}) {
    let map = {
      [Reservation.ADMIN]: 'admin',
      [Reservation.PERSONAL]: 'order_object',
      [Reservation.ORG]: 'order_group',
      [Reservation.LETTER]: 'order_business'
    }
    let f = Object.assign({orderType: map[type] || ''}, filter || {})
    let {items, amount} = await dispatch('getDataList', {
      url: `/passObjectApi/order/list/history${self ? '/self' : ''}`,
      pagination,
      sortStack,
      search,
      transDict: {
        plate: 'visitorObjectCode',
        startDatetime: 'sdtime',
        endDatetime: 'edtime'
      },
      filter: f
    }, {root: true})
    return {
      items: items.map(item => {
        let order = item.order
        order.visitor = Visitor.fromAPI(item.visitor)
        order.owner = item.personLiable
        order.applicant = item.user
        return Reservation.fromAPI(order)
      }),
      amount
    }
  },
  async getAdminReservations ({dispatch}, params) {
    return dispatch('getReservations', {...params, type: Reservation.ADMIN})
  },
  async getOrgReservations ({dispatch}, {pagination, filter, search, sortStack}) {
    let {items, amount} = await dispatch('getDataList', {
      url: `/passObjectApi/group/info/all`,
      pagination,
      filter: {...filter, type: {key: 'type', value: ['order_group']}},
      search,
      transDict: {status: 'RHData', host: 'orgId'},
      sortStack
    }, {root: true})
    return {items: items, amount: amount}
  },
  async getOrgReservationsHistory ({dispatch}, params) {
    return dispatch('getReservationsHistory', {...params, type: Reservation.ORG})
  },
  async getPersonalReservations ({dispatch}, {pagination, filter, search, sortStack}) {
    let {items, amount} = await dispatch('getDataList', {
      url: `/passObjectApi/group/info/all`,
      pagination,
      filter: {...filter, type: {key: 'type', value: ['order_object']}},
      search,
      transDict: {status: 'RHData', host: 'orgId'},
      sortStack
    }, {root: true})
    return {items: items, amount: amount}
  },
  async getPersonAdminReservations({dispatch}, {pagination, filter, search, sortStack}) {
    let {items, amount} = await dispatch('getDataList', {
      url: `/passObjectApi/group/info/all`,
      pagination,
      filter: {...filter, type: {key: 'type', value: ['admin']}},
      search,
      transDict: {status: 'RHData', host: 'orgId'},
      sortStack
    }, {root: true})
    return {items: items, amount: amount}
  },
  async getPersonalReservationsHistory ({dispatch}, params) {
    return dispatch('getReservationsHistory', {...params, type: Reservation.PERSONAL})
  },
  async getReservationGroups ({dispatch}, {pagination, filter, search, sortStack}) {
    let {items, amount} = await dispatch('getDataList', {
      url: `/passObjectApi/group/info/all`,
      pagination,
      filter: {...filter},
      search,
      transDict: {status: 'RHData', host: 'orgId'},
      sortStack
    }, {root: true})
    return {items: items, amount: amount}
  },
  async getReservationGroupsHistory ({dispatch}, {pagination, filter, search, sortStack}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/passObjectApi/group/info/all/history',
      pagination,
      filter: {...filter, type: {key: 'type', value: ['admin']}},
      search,
      sortStack
    }, {root: true})
    return {items: items, amount: amount}
  },

  async setReservationGroup ({dispatch}, group) {
    let res = await dispatch('getDataFromApi', {
      url: '/passObjectApi/group/',
      method: 'put',
      data: {
        'id': group.id,
        'name': group.name,
        'description': group.description,
        'priority': group.priority,
        'osdMsgIn': group.ledPromptIn,
        'vcbMsgIn': group.audioPromptIn,
        'osdMsgOut': group.ledPromptOut,
        'vcbMsgOut': group.audioPromptOut
      }
    }, {root: true})
    return ReservationGroup.fromAPI(res)
  },

  async getRules ({dispatch, rootState}, {pagination, sortStack, search, filter, group, groupId, RHData = ''}) {
    let f = Object.assign({groupId: (group && group.id) || groupId || ''}, {RHData: RHData}, filter || {})
    if (!f.groupId) return {items: [], amount: 0}

    f.groupId = {key: 'groupId', value: f.groupId, precious: true}
    let {items, amount} = await dispatch('getDataList', {
      url: `/passObjectApi/pass/rule`,
      pagination,
      sortStack,
      search,
      transDict: {
        'startDatetime': 'sdtime',
        'endDatetime': 'edtime',
        'audioPrompt': 'vcbMsgAllowed',
        'ledPrompt': 'osdMsgAllowed',
        'audioPromptIn': 'vcbMsgIn',
        'ledPromptIn': 'osdMsgIn',
        'audioPromptOut': 'vcbMsgOut',
        'ledPromptOut': 'osdMsgOut',
        'ruleType': 'segmentType',
        'groupId': 'ownerId'
      },
      filter: f
    }, {root: true})
    let controllers = rootState.parkingLot.personControllerList
    return {items: items.map(item => PassRule.fromAPI(item, controllers)), amount}
  },

  async setRule ({dispatch, rootState}, rule) {
    let res = await dispatch('getDataFromApi', {
      url: '/passObjectApi/pass/rule/controller',
      method: 'put',
      data: {
        'passrule': rule.toAPI()
      }
    }, {root: true})
    return PassRule.fromAPI(res, rootState.parkingLot.controllerList)
  },
  async setSpecificRule ({dispatch, rootState}, rule) {
    let res = await dispatch('getDataFromApi', {
      url: '/passObjectApi/pass/rule/controller',
      method: 'put',
      data: {
        'passrule': rule.toAPI()
      }
    }, {root: true})
    let s = SpecificRule.fromAPI(res, rootState.parkingLot.controllerList)
    if (rule.isStandalone) {
      await dispatch('pass/setStandalone', {
        vehicle: s.vehicle,
        value: rule.isStandalone
      }, {root: true})
      s.isStandalone = rule.isStandalone
    }
    return s
  },
  async deleteRules ({dispatch}, rules) {
    return dispatch('getDataFromApi', {
      url: '/passObjectApi/pass/rule/',
      method: 'delete',
      data: {
        ids: rules.map(r => r.id)
      }
    }, {root: true})
  },
  async deleteGroups ({dispatch}, groups) {
    return dispatch('getDataFromApi', {
      url: '/passObjectApi/group/',
      method: 'delete',
      data: {
        ids: groups.map(g => g.id)
      }
    }, {root: true})
  },
  async getSpecifics ({dispatch}, {pagination, sortStack, search, filter, vehicle, plate}) {
    return dispatch('getRules', {
      pagination,
      sortStack,
      search,
      filter,
      groupId: (vehicle && vehicle.plate) || plate
    })
  },
  async getAllSpecifics ({dispatch, rootState}, {pagination, sortStack, search, filter, group}) {
    let res = await dispatch('getDataList', {
      url: `/passObjectApi/object/standalone/group/${group.id}`,
      pagination,
      sortStack,
      search,
      filter,
      returnRaw: true
    }, {root: true})

    let items = []
    res.forEach(({passrule, object, isStandalone}) => {
      if (passrule) {
        passrule.forEach(p => {
          p.isStandalone = !!(+isStandalone)
        })
        items.push(...passrule)
      }
    })
    return {
      items: items.map(r => SpecificRule.fromAPI(r, rootState.parkingLot.personControllerList)),
      amount: items.length
    }
  },
  async getVehicleFileTemplate () {
    return "https://smaco2.uestc.edu.cn/passApi/files/%E9%A2%84%E7%BA%A6%E4%BA%BA%E8%A1%8C%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx"
  },
  async getAdminOrg ({dispatch}, self) {
    let orgId = self.insId
    if (!orgId) {
      let e = {
        code: 0,
        message: '未获取到您所在的机构ID，请刷新浏览器重试'
      }
      throw e
    }
    return dispatch('getDataFromApi', {
      method: 'get',
      url: `/passObjectApi/check/groups/admin/`,
      params: {
        id: self.id
      }
    }, {root: true})
  },
  async submitReservation ({dispatch, rootGetters, rootState}, {reservationGroup, type}) {
    let vehicles = reservationGroup.vehicles
    let rules = reservationGroup.rules
    let typeMap = {
      [Reservation.ADMIN]: 'admin',
      [Reservation.ORG]: 'order_group',
      [Reservation.PERSONAL]: 'order_object',
      [Reservation.LETTER]: 'order_business'
    }
    let extend = reservationGroup.extend
    let data = {
      'extend': JSON.stringify(extend),
      'orderType': typeMap[type],
      'name': reservationGroup.name,
      'description': reservationGroup.description,
      'sinNum': reservationGroup.sinNum || '',
      'validTime': reservationGroup.validTime || '',
      // host
      personLiable: reservationGroup.owner.loginId || '',
      // applicant
      'ownerId': reservationGroup.applicant.loginId || '',
      obgrp: {
        name: reservationGroup.name,
        description: reservationGroup.description,
        osdMsgOut: reservationGroup.ledPromptOut,
        osdMsgIn: reservationGroup.ledPromptIn,
        vcbMsgIn: reservationGroup.audioPromptIn,
        vcbMsgOut: reservationGroup.audioPromptOut
      },
      passrule: rules.map(r => r.toAPI()),
      orders: []
    }

    vehicles.forEach(v => {
      data.orders.push({
        'visitorPhone': v.ownerTel,
        'visitorObjectCode': v.plate,
        visitorName: v.ownerName,
        visitorOrg: v.ownerOrg,
        'visitorIdNum': v.ownerIDNumber || '',
        'visitorIdType': v.ownerIDType || ''
      })
    })

    let group = rootState.login.self.orgGroup || {}
    let message = {
      method: 'put',
      url: '/passObjectApi/order/',
      data: data
    }
    if (typeof reservationGroup.id !== 'undefined') {
      message.url = '/passObjectApi/order/?obgrpId=' + reservationGroup.id
    }
    if (type === Reservation.ORG) {
     /* message.params = {
        groupId: group.id || '',
        orgId: group.insId
      }*/
    }
    let res = await dispatch('getDataFromApi', message, {root: true})
    return ReservationGroup.fromAPI(res)
  },
  /*  async getVehicles ({dispatch}, {group, pagination, sortStack, search, filter = {}, locate = 'runtime'}) {
    let {items, amount} = await dispatch('getDataList', {
      url: `/passApi/object/list/${locate}`,
      pagination,
      sortStack,
      search,
      filter: {...filter, obgrpId: group.id},
      transDict: {
        plate: 'objectId',
        phone: 'objectPhone'
      }
    }, {root: true})
    return {
      items: items.map(v => new Vehicle({
        plate: v.objectId,
        owner: {
          phone: v.objectPhone
        }
      })),
      amount
    }
  } */
  async getVehicles ({dispatch}, {group, pagination, sortStack, search, filter = {}, locate = 'runtime'}) {
    let {items, amount} = await dispatch('getDataList', {
      url: `/passObjectApi/order/list`,
      pagination,
      sortStack,
      search,
      filter: {...filter, obgrpId: group.id, orderType: ''},
        transDict: {
        plate: 'visitorObjectCode',
        status: 'RHData',
        startDatetime: 'sdtime',
        endDatetime: 'edtime',
      }
    }, {root: true})
    return {
      items: items.map(item => {
        let order = item.order
        order.visitor = Visitor.fromAPI(item.visitor)
        order.owner = item.personLiable
        order.applicant = item.user
        return Reservation.fromAPI(order)
      }),
      amount
    }
  },
  async deleteVehicles ({dispatch}, ids) {
    let url = '/passObjectApi/order/'
    try {
      let res = await axios.delete(url, {data: {
        'ids': ids
      }})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async getReservationObgrp ({dispatch}, {ownerId}) {
    // noinspection JSAnnotator
    let {items, amount} = await dispatch('getDataList', {
      url: `/passObjectApi/group/info/all`,
      pagination: {page: 1, rowsPerPage: 10},
      filter: {id: {key: 'id', value: ownerId}},
      search: '',
    }, {root: true})
    return {items: items, amount: amount}
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
